import { render, staticRenderFns } from "./ValueToJson.vue?vue&type=template&id=3b2887fe&"
import script from "./ValueToJson.vue?vue&type=script&lang=js&"
export * from "./ValueToJson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports